export const CashinClosingState = {
    IN_PROGRESS: 'IN_PROGRESS',
    RESULT: 'RESULT',
    OFFER: 'OFFER',
    NOT_AVAILABLE: 'NOT_AVAILABLE',
    ERROR: 'ERROR'
};

export const CashinTransactionStatus = {
    Started: 'Started',
    Activated: 'Activated',
    AuthorizationRequired: 'AuthorizationRequired',
    Approved: 'Approved',
    Rejected: 'Rejected'
};
